module.exports = __webpack_public_path__ + "static/img/image.294de88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image.jpg
// module id = 3UDv
// module chunks = 1